import React from "react";
import { ThemeProvider } from "onnit-ui/lib/themes/styled";
import GlobalStyle from "onnit-ui/lib/themes/GlobalStyle";
import theme from "onnit-ui/lib/themes/light";
import Box from "onnit-ui/lib/box/Box";
import useOnnitContext from "onnit-ui/lib/hooks/useOnnitContext";
import usePageData from "../../hooks/usePageData";
import { Img, Picture } from "onnit-ui/lib/image";
import TwelveColumn from "onnit-ui/lib/module/grid/12/Grid";
import ImageContentPortrait from "onnit-ui/lib/module/ImageContentPortrait";
import Text, { List, ListItem, Sup } from "onnit-ui/lib/text";
import LabelContent from "onnit-ui/lib/module/LabelContent";
import MediaCollage03 from "onnit-ui/lib/module/MediaCollage03";
import Embed from "onnit-ui/lib/video/Embed";
import SupplementFacts from "../../components/common/SupplementFacts";
import UsageAndDisclaimers from "../../components/common/UsageAndDisclaimers";
import { Offer, Offers } from "../../components/common/offer/Offers";
import FiveStarTestimonials from "../../components/common/FiveStarTestimonials";
import testimonials from "../total-human-trial/testimonials";
import ProductBoxDisplay from "../../components/common/ProductBoxDisplay";
import dayPackIngredients from "../total-human-trial/day-pack-ingredients";
import nightPackIngredients from "../total-human-trial/night-pack-ingredients";
import Faqs from "../../components/common/Faqs";
import faqs from "./faq";
import OnnitLogoBackground from "../../components/common/OnnitLogoBackground";
import AsSeenIn from "./AsSeenIn";
import Button from "onnit-ui/lib/button/Button";
import useScrollToRef from "../../hooks/useScrollToRef";
import OnnitLogo from "onnit-ui/lib/logo/OnnitLogo";

function Page() {
    const onnitContext = useOnnitContext();
    const { pageData } = usePageData();
    const [buyBoxRef, scrollToBuyBox] = useScrollToRef();

    if (!pageData || !onnitContext) return null;

    const IMG_PARAMS = "?q=40&fm=pjpg&auto=compress,format";
    const IMG_URL = onnitContext.url.cdn.static_images + "/product-page/total-human-trial";
    const OFFER_IMG_URL = onnitContext.url.cdn.static_images + "/product-page/total-human-offer";

    const darkTeal = "#54C2B7";
    const sunwashGolder = "#D0B16E";

    const TH1x = pageData.products.find((product) => product.id === 8560);
    const TH1xSub = pageData.products.find((product) => product.id === 8561);
    const TH2x = pageData.products.find((product) => product.id === 8562);
    const TH3x = pageData.products.find((product) => product.id === 8563);

    if (!TH1x || !TH1xSub || !TH2x || !TH3x) {
        console.error("Offer product missing in page data");
        return null;
    }

    return (
        <ThemeProvider theme={theme}>
            <>
                <GlobalStyle />
                <div
                    className="bg-black white block center font-family-nexa  bold fz1 sm-fz2 p1 lsn1 no-hover-underline"
                    data-promotion='{"name":"Global Banner - Alpha BRAIN collection","position":1}'
                >
                    <span>
                        TOTAL HUMAN
                        <Sup variant="reg" /> IS RATED 5.0 STARS BY 1000+ CUSTOMERS!
                    </span>
                </div>
                <div className="hide-ie">
                    <Box display={"grid"} gridTemplateColumns="repeat(12, 1fr)">
                        <Box zIndex={1} gridRow="1" gridColumn="1 / -1" display="flex">
                            <Picture
                                lazyLoad={false}
                                width={1456}
                                height={754}
                                src={[
                                    `${OFFER_IMG_URL}/offer-hero-mobile.png${IMG_PARAMS}`,
                                    `${OFFER_IMG_URL}/offer-hero-desktop.png${IMG_PARAMS}`,
                                ]}
                                alt="Onnit Offer Hero Background Image"
                                style={{ objectFit: "cover", height: "100%" }}
                            />
                        </Box>
                        <Box
                            zIndex={2}
                            gridRow="1"
                            gridColumn={["1 / -1", "1 / -1", "2 / span 6"]}
                            display={["block", "block", "flex"]}
                            flexDirection="column"
                            justifyContent="center"
                            maxWidth={["100%", "100%", "648px"]}
                        >
                            <Box
                                bg={"rgba(0,0,0,0.5)"}
                                height={["100%", "100%", "auto"]}
                                px={5}
                                py={7}
                                display="flex"
                                justifyContent="center"
                                flexDirection="column"
                            >
                                <Box display="flex">
                                    <OnnitLogo color="white" mx="auto" mb={4} />
                                </Box>
                                <Text
                                    typeStyle="copyDisplay02"
                                    fontSize={[4, 4, 6, 6, 6, 7, 7]}
                                    color="sunwashGold"
                                    mb={4}
                                    textTransform="uppercase"
                                    as="h1"
                                >
                                    Ready to Level Up? Total Human
                                    <Sup variant="reg" /> is the easiest way to optimize your body!
                                </Text>
                                <Text color="white" mb={6} fontSize={[2, 2, 4]}>
                                    Convenient day and night packs—complete with essential vitamins, minerals, herbs,
                                    and amino acids—to make optimization easy.
                                    <Sup />
                                </Text>
                                <Button
                                    size="medium"
                                    width={[1, 1, "auto"]}
                                    onClick={() => scrollToBuyBox()}
                                    textColor="black"
                                    color="white"
                                    raised
                                >
                                    TRY IT NOW - RISK FREE
                                </Button>
                            </Box>
                        </Box>
                    </Box>

                    <AsSeenIn />

                    <Box bg="#232523" px={[4, 4, 4, 0]}>
                        <TwelveColumn>
                            <Box gridColumn={["1 / -1", "1/-1", "1/-1", "3 / span 8"]} pt={8}>
                                <Text
                                    as="h2"
                                    fontWeight="black"
                                    textTransform="uppercase"
                                    display="inline"
                                    fontSize={[8, 11, 12, 13, 14]}
                                    lineHeight={0}
                                    mb={6}
                                    mt={3}
                                >
                                    <Text
                                        as="span"
                                        textTransform="uppercase"
                                        fontSize={[8, 11, 12, 13, 14]}
                                        lineHeight={0}
                                        color="white"
                                        display="inline"
                                    >
                                        Ready to
                                    </Text>
                                    <br />
                                    <Text
                                        as="span"
                                        textTransform="uppercase"
                                        fontSize={[8, 11, 12, 13, 14]}
                                        lineHeight={0}
                                        color={darkTeal}
                                        display="inline"
                                    >
                                        Get Optimized?
                                    </Text>
                                </Text>
                            </Box>
                            <Box gridColumn={["1 / -1", "1/-1", "1/-1", "5 / span 6"]} pt={4}>
                                <Text as="p" textTransform="uppercase" color="white" typeStyle="copyHero02">
                                    Discover a re-imagining of the daily multivitamin. Choose your package and save big
                                    on your order of Total Human
                                    <Sup variant="reg" />
                                </Text>
                            </Box>
                        </TwelveColumn>
                    </Box>

                    <Box bg="#232523" py={6} ref={buyBoxRef}>
                        <Offers>
                            <Offer
                                borderColor={darkTeal}
                                title={`1 Month`}
                                products={[TH1x, TH1xSub]}
                                packageQuantity={1}
                                containerType="Box"
                                servingSize="30 Servings"
                                buyBtnText="TRY IT NOW - RISK FREE"
                            >
                                <Img
                                    width={850}
                                    height={604}
                                    src={`${OFFER_IMG_URL}/boxes-1-freegift.png${IMG_PARAMS}`}
                                    alt={TH1x.name}
                                />
                            </Offer>

                            <Offer
                                borderColor="sunwashGold"
                                title={`2 Months`}
                                products={[TH2x]}
                                packageQuantity={2}
                                containerType="Box"
                                buyBtnText="TRY IT NOW - RISK FREE"
                                rating={4.5}
                                numReviews="900+"
                                offerFinePrintText="This offer is so good, no other coupons are applicable"
                            >
                                <Img
                                    width={850}
                                    height={604}
                                    src={`${OFFER_IMG_URL}/boxes-2-freegift.png${IMG_PARAMS}`}
                                    alt={TH2x.name}
                                />
                                <List ml={4} mb={4}>
                                    <ListItem fontWeight="bold" mb={3} lineHeight={2}>
                                        FREE Facts of Life E-Book by Joe Rogan
                                    </ListItem>
                                    <ListItem fontWeight="bold" mb={3} lineHeight={2}>
                                        Nutritional support for the brain, bones, joints, mood, immune system, and
                                        energy.{""}
                                        <Sup />
                                    </ListItem>
                                    <ListItem fontWeight="bold" mb={3} lineHeight={2}>
                                        Convenient day and night packs so you know what to take and when.
                                    </ListItem>
                                    <ListItem fontWeight="bold" mb={3} lineHeight={2}>
                                        Includes Onnit’s most popular supplements all in one place.
                                    </ListItem>
                                    <ListItem fontWeight="bold" mb={3} lineHeight={2}>
                                        You SAVE, versus buying each component supplement individually.
                                    </ListItem>
                                    <ListItem fontWeight="bold" mb={3} lineHeight={2}>
                                        Dairy Free
                                    </ListItem>
                                    <ListItem fontWeight="bold" mb={3} lineHeight={2}>
                                        Gluten Free
                                    </ListItem>
                                </List>
                            </Offer>

                            <Offer
                                borderColor={darkTeal}
                                title={`3 Months`}
                                products={[TH3x]}
                                packageQuantity={3}
                                containerType="Box"
                                buyBtnText="TRY IT NOW - RISK FREE"
                                offerFinePrintText="This offer is so good, no other coupons are applicable"
                            >
                                <Img
                                    width={850}
                                    height={604}
                                    src={`${OFFER_IMG_URL}/boxes-3-freegift.png${IMG_PARAMS}`}
                                    alt={TH3x.name}
                                />
                            </Offer>
                        </Offers>
                    </Box>
                    <Box bg="black" pt={[6, 6, 8]}>
                        <LabelContent
                            label={
                                <Text typeStyle="copy05" color={darkTeal}>
                                    Total Human
                                    <Sup variant="reg" />
                                </Text>
                            }
                            content={
                                <>
                                    <Text
                                        as="h3"
                                        typeStyle="copyHero02"
                                        color={darkTeal}
                                        textTransform="uppercase"
                                        mb={6}
                                    >
                                        Get all the Nutrition you need in a day to think, feel, and perform at your
                                        best.
                                    </Text>
                                    <List ml={4} mb={4}>
                                        <ListItem color="white" mb={3} lineHeight={2}>
                                            Nutritional support for the brain, bones, joints, mood, immune system, and
                                            energy.{""}
                                            <Sup />
                                        </ListItem>
                                        <ListItem color="white" mb={3} lineHeight={2}>
                                            Convenient day and night packs so you know what to take and when.
                                        </ListItem>
                                        <ListItem color="white" mb={3} lineHeight={2}>
                                            Includes Onnit’s most popular supplements all in one place.
                                        </ListItem>
                                        <ListItem color="white" mb={3} lineHeight={2}>
                                            You SAVE, versus buying each component supplement individually.
                                        </ListItem>
                                    </List>
                                </>
                            }
                        />
                    </Box>
                    <Box bg="black">
                        <MediaCollage03
                            pb={[6, 6, 8, 10]}
                            item1={
                                <Img
                                    src={`${IMG_URL}/mma-girl-benefits-collage-1.png${IMG_PARAMS}`}
                                    alt="MMA Girl kicking"
                                    width={1170}
                                    height={656}
                                />
                            }
                            item2={
                                <Img
                                    src={`${IMG_URL}/guy-benefits-collage-2.png${IMG_PARAMS}`}
                                    alt="Side profile image of man"
                                    width={448}
                                    height={448}
                                />
                            }
                            item3={
                                <Img
                                    width={688}
                                    height={376}
                                    src={`${OFFER_IMG_URL}/steel-club.jpg${IMG_PARAMS}`}
                                    alt="Man with Steel club"
                                />
                            }
                        />
                    </Box>

                    <Box py={[6, 6, 8]} backgroundColor={sunwashGolder}>
                        <ImageContentPortrait
                            image={
                                <Img
                                    width={928}
                                    height={928}
                                    src={`${OFFER_IMG_URL}/aubrey-marcus.jpg${IMG_PARAMS}`}
                                    alt="Aubrey Marcus, Chairman and Founder of Onnit"
                                />
                            }
                            content={
                                <Box display="flex" flexDirection="column" height="100%" justifyContent="center">
                                    <Text as="p" typeStyle="copy02" fontWeight="regular" mb={4}>
                                        If you don&rsquo;t know where to start, take Total Human
                                        <Sup variant="reg" />! I heard from a lot of Onnit customers that they loved our
                                        supplements, but didn&rsquo;t know what to try next. They&rsquo;d love to try
                                        all of them, but didn&rsquo;t have the time or budget to experiment on what
                                        works best for them. So, we created Total Human
                                        <Sup variant="reg" /> to make it super easy for anyone to get the next-level
                                        daily vitamins and nutrients they need to be at their best.
                                    </Text>
                                    <Text
                                        as="p"
                                        typeStyle="copy02"
                                        fontStyle="italic"
                                        fontWeight="bold"
                                        pt={4}
                                        mb={4}
                                        display="inline-block"
                                    >
                                        &mdash; Aubrey Marcus
                                        <br />
                                        <Text as="span" typeStyle="copy02" fontStyle="italic" fontSize={[2, 3, 4]}>
                                            Chairman and Founder of Onnit
                                        </Text>
                                    </Text>
                                </Box>
                            }
                        />
                    </Box>

                    <Box mx="auto" mt={8}>
                        <ImageContentPortrait
                            image={
                                <Img
                                    src={`${OFFER_IMG_URL}/day-ingredients.png${IMG_PARAMS}`}
                                    alt="Hand holding day pack ingredients"
                                />
                            }
                            content={
                                <Box display="flex" flexDirection="column" height="100%" justifyContent="center">
                                    <Text color="black" typeStyle="copyDisplay02" mb={[4, 4, 6]}>
                                        Day Pack <br />
                                        Ingredients
                                    </Text>
                                    <Text as="p" typeStyle="copy02" fontWeight="regular">
                                        Whether you&rsquo;re at work, working out, or otherwise doing what you love, the
                                        Total Human
                                        <Sup variant="reg" /> Day Pack supports your focus, energy, endurance, and
                                        general wellness to keep you on point and performing effortlessly at your best.
                                        <Sup />
                                    </Text>
                                </Box>
                            }
                        />

                        <Box
                            px={[0, 0, 0, 6, 8]}
                            display="grid"
                            gridTemplateColumns="repeat(auto-fit, minmax(320px, 1fr))"
                            mt={8}
                        >
                            {dayPackIngredients.map((ingredient, index) => (
                                <ProductBoxDisplay
                                    key={index}
                                    title={ingredient.title}
                                    content={ingredient.content}
                                    imgUrl={`${IMG_URL}/${ingredient.img}${IMG_PARAMS}`}
                                    altText={ingredient.altText}
                                />
                            ))}
                        </Box>
                    </Box>

                    <Box mx="auto" mt={[6, 6, 6, 8]} pt={8} pb={[6, 6, 6, 8]} backgroundColor="grays.0">
                        <ImageContentPortrait
                            image={
                                <Img
                                    src={`${OFFER_IMG_URL}/night-ingredients.png${IMG_PARAMS}`}
                                    alt="Hand holding night pack ingredients"
                                />
                            }
                            content={
                                <Box display="flex" flexDirection="column" height="100%" justifyContent="center">
                                    <Text color="sunwashGolder" typeStyle="copyDisplay02" mb={[4, 4, 6]}>
                                        Night Pack <br />
                                        Ingredients
                                    </Text>
                                    <Text as="p" typeStyle="copy02" fontWeight="regular">
                                        Your physical, mental, and emotional state is different in the evening than it
                                        was in the morning. Just as you wouldn't drink coffee to fall asleep, the
                                        ingredients that assist you when you’re at work or working out are not the same
                                        ones you need to help you relax and recover at the end of the day. The Total
                                        Human
                                        <Sup variant="reg" /> Night Pack helps you turn off the lights with a peaceful
                                        smile, and nourishes your body with the raw materials it needs to wake up
                                        feeling rested and energized.
                                    </Text>
                                </Box>
                            }
                        />

                        <Box
                            px={[0, 0, 0, 6, 8]}
                            display="grid"
                            gridTemplateColumns="repeat(auto-fit, minmax(320px, 1fr))"
                            mt={8}
                        >
                            {nightPackIngredients.map((ingredient, index) => (
                                <ProductBoxDisplay
                                    key={index}
                                    title={ingredient.title}
                                    content={ingredient.content}
                                    imgUrl={`${IMG_URL}/${ingredient.img}${IMG_PARAMS}`}
                                    altText={ingredient.altText}
                                />
                            ))}
                        </Box>
                    </Box>

                    <OnnitLogoBackground
                        fillColor="#54c2b7"
                        fillOpacity={0.1}
                        bgFillColor="black"
                        backgroundColor="#000000"
                        backgroundSize="cover"
                    >
                        <FiveStarTestimonials
                            titleColor={darkTeal}
                            title={
                                <>
                                    What customers are saying about Total Human
                                    <Sup variant="reg" />
                                </>
                            }
                            testimonials={testimonials}
                            textColor="white"
                        />
                        <Box display="flex" justifyContent="center" py={6}>
                            <Button
                                size="medium"
                                width={[1, 1, "auto"]}
                                onClick={() => scrollToBuyBox()}
                                textColor="black"
                                color="white"
                                raised
                            >
                                TRY IT NOW - RISK FREE
                            </Button>
                        </Box>
                    </OnnitLogoBackground>

                    <TwelveColumn mt={[0, 0, 0, 8]} mb={[6, 6, 6, 8]}>
                        <Box gridColumn={["1 / -1", "1/-1", "1/-1", "4 /span 6"]}>
                            <Embed title="Total Human® Product Video" src="https://player.vimeo.com/video/466390434" />
                        </Box>
                    </TwelveColumn>
                </div>

                <Faqs faqs={faqs} />

                <UsageAndDisclaimers supplementFacts={<SupplementFacts enableZoom={true} />}>
                    <Text
                        fontSize={0}
                        color="grays.4"
                        target="_blank"
                        href="/terms-and-conditions/subscription/"
                        as="a"
                    >
                        Read the Subscription Terms and Conditions here.
                    </Text>
                </UsageAndDisclaimers>
            </>
        </ThemeProvider>
    );
}

export default Page;
